export default __webpack_public_path__ + "static/media/illustration-mobile.15b067d5.svg";